export const L10N = {
  ACTION_CLUB_VIEW_CONDITIONS: { id: 'core.action.club_view_conditions' },
  ACTION_LOGIN: { id: 'common.action.login' },
  ACTION_MORE_INFO: { id: 'common.action.more_info' },

  LABEL_CLUB_MEMBERS_EXCLUSIVE: { id: 'core.label.club_members_exclusive' },
  LABEL_CLUB_CONDITIONS: { id: 'core.label.club_conditions' },
  LABEL_LOGIN_NOW: { id: 'core.label.login_now' },
  LABEL_ONLY_MEMBERS: { id: 'core.label.only_members' },
  LABEL_UNLOCK_EXCLUSIVE_MEMBER: { id: 'core.label.unlock_exclusive_member' },
};
